import { Directive, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { PackageTypeService } from '../package-type.service'

@Directive({
  selector: '[appPackageTypeSelect]',
})
export class PackageTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const typeService = inject(PackageTypeService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'context.type'
    this.select.dataSource = typeService
    this.select.sorts = [new Sort('id', 'asc')]
  }
}
